"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18n = exports.init = void 0;
var merge_1 = __importDefault(require("lodash/merge"));
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var mapValues_1 = __importDefault(require("lodash/mapValues"));
var forEach_1 = __importDefault(require("lodash/forEach"));
var StringFomat_1 = require("../utils/StringFomat");
var utils_1 = require("../utils");
var const_1 = require("../const");
var services_1 = require("../services");
var cacheI18ns = [];
function makeCacheI18n($i18n, params) {
    if (params === void 0) { params = {}; }
    if (typeof cacheI18ns === 'undefined') {
        return;
    }
    cacheI18ns.push({
        params: params,
        $i18n: $i18n,
    });
}
function getCacheI18n(params) {
    if (params === void 0) { params = {}; }
    if (typeof cacheI18ns === 'undefined') {
        return null;
    }
    var theCache = cacheI18ns.find(function (cache) { return (0, isEqual_1.default)(cache.params, params); });
    if (theCache) {
        return theCache.$i18n;
    }
    return null;
}
// 为了兼容老的代码，这里暂时保留一个占为的对象
var localeUtil = {
    locale: {
        getLocale: function () {
            (0, utils_1.warn)('Legacy api! Please use $i18n.getLang instead!');
            return { lang: defaultI18n.getLang() };
        },
        setLang: function (lang) {
            (0, utils_1.warn)('Legacy api! Please use $i18n.setLang instead!');
            defaultI18n.setLang(lang);
        },
    },
};
var I18n = /** @class */ (function () {
    function I18n(params) {
        var _this = this;
        /**
         * 用组件自持有翻译初始化stringformat实例
         * @param {object} locale 组件自持有翻译
         * @param {string} defaultLang 自定义语种
         */
        this.locale = {};
        /** 当前实例的实际语种 */
        this.currentLang = '';
        /** $i18n组件名（组件独有） */
        this.componentName = '';
        this.localeUtil = localeUtil;
        this.initFlag = true;
        this.componentName = (params === null || params === void 0 ? void 0 : params.componentName) || '';
        this.name = this.componentName
            ? "".concat(this.componentName, ".").concat((0, utils_1.getRandomKey)())
            : (0, utils_1.getRandomKey)();
        // 当指定了lang之后该实例将锁定lang，不再受环境和事件影响
        if (params === null || params === void 0 ? void 0 : params.lang) {
            this.customLang = params.lang;
        }
        if ((params === null || params === void 0 ? void 0 : params.locale) && this.componentName) {
            // 组件可能传递是会多一层nameSpace，需要脱离，如果是组件不需要合并cdn的文案
            // ILocalResource | ILocalResourceWithNs => ILocalResource
            this.locale = (0, mapValues_1.default)(params.locale, function (_langLocale) { return _langLocale[_this.componentName] || _langLocale; });
            // 合并语言包文案
            if (window._PANDA_EXUI) {
                Object.keys(window._PANDA_EXUI).forEach(function (lang) {
                    if (window._PANDA_EXUI[lang][_this.componentName]) {
                        _this.locale[lang] = (0, merge_1.default)(_this.locale[lang] || {}, window._PANDA_EXUI[lang][_this.componentName]);
                    }
                });
            }
        }
        else {
            this.locale = (0, merge_1.default)({}, (0, utils_1.convertPandaI18nFormatToLocalResource)(window._PANDA_I18N), (params === null || params === void 0 ? void 0 : params.locale) || {});
        }
        this.currentLang = (params === null || params === void 0 ? void 0 : params.lang) || (0, utils_1.getLangValue)();
        services_1.pandaEvent.on('CHANGE_LANG', function (lang) {
            if (!_this.customLang) {
                _this.currentLang = lang;
            }
        });
        if (params === null || params === void 0 ? void 0 : params._init) {
            // 如果是默认实例，将实例名放到对象，用于排查问题
            window.__PANDA.instanceNames.push(this.name);
            this.initFlag = false;
            (0, utils_1.debuginfo)("".concat(this.name, ": ").concat(const_1.VERSION));
        }
        // lang只记录强制lang，环境lang跟随环境走
        (0, StringFomat_1.initial)(this.locale, { name: this.name, lang: this.customLang });
    }
    I18n.prototype.init = function (params) {
        if (getCacheI18n(params)) {
            return getCacheI18n(params);
        }
        var _$i18n = new I18n(__assign({}, params));
        makeCacheI18n(_$i18n, params);
        return _$i18n;
    };
    /**
     * change current language
     * @param {string} langTag language tag config above
     * @deprecated 之后将逐步废弃此方法
     */
    I18n.prototype.change = function (langTag) {
        (0, utils_1.warn)('Legacy api! Please use $i18n.setLang instead!');
        this.setLang(langTag);
    };
    /**
     * change current language
     * @param {string} langTag language tag config above
     */
    I18n.prototype.setLang = function (langTag) {
        // 由于后续的文案消费依赖标准的format，故设置需要做处理
        var standardLang = (0, utils_1.formatLocale)(langTag);
        if (standardLang !== langTag) {
            (0, utils_1.error)("".concat(langTag, " is not a valid language tag, panda converts to ").concat(standardLang, " instead\uFF0Cplease check usage."));
        }
        // set cookie, 由于使用中依然 后端可能存在依然使用老的规范，故设置cookie依然使用用户设置的值
        (0, utils_1.setCookieLang)(langTag);
        // set window
        this.currentLang = standardLang;
        if (window.__PANDA) {
            window.__PANDA.lang = standardLang;
        }
        // set localStorage
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem(const_1.DEFAULT_LOCAL_KEY, standardLang);
        }
        services_1.pandaEvent.emit('CHANGE_LANG', standardLang);
    };
    /**
     * get current language
     */
    I18n.prototype.getLang = function () {
        return this.currentLang;
    };
    /**
     * Format string by key
     * For example:
     * $i18n.get('jsx.home.title'),
     * $i18n.get({
     *    id: 'jsx.home.hello',
     *    dm: 'Hello {name}' // not required
     * },{
     *  name: 'Alice'
     * })
     * More syntax: https://formatjs.io/guides/message-syntax/
     * @param {string|object} id key or object
     * @param {object} variable variable for id
     * @param {object}  env env information, cookieName
     * @return {string} format message
     */
    I18n.prototype.get = function (keyValue, variable) {
        // 为了处理加载时序的问题，针对CDN场景，在第一次使用$i18n.get时再进行实际的实例化
        if (!defaultI18n.initFlag) {
            defaultI18n.initFlag = true;
            // FIXME: 存在多个语言包挂载的cookieKey不同的情况
            // cdn 语言包设置的cookieKey
            if (Object.keys(window._PANDA_I18N).length) {
                var langCookieName = Object.values(window._PANDA_I18N)[0].langCookieName;
                if (langCookieName) {
                    window.__PANDA.cookieKey = langCookieName;
                }
            }
            defaultI18n.currentLang = defaultI18n.customLang || (0, utils_1.getLangValue)();
            window.__PANDA.lang = defaultI18n.currentLang;
            defaultI18n.addLocale((0, utils_1.convertPandaI18nFormatToLocalResource)(window._PANDA_I18N));
        }
        var id = typeof keyValue === 'string' ? keyValue : keyValue.id;
        var defaultString = typeof keyValue === 'string' ? keyValue : keyValue.dm;
        // namespace 当前只针对组件名
        var nameSpace = typeof keyValue === 'string'
            ? this.componentName
            : keyValue.ns || this.componentName;
        // 指定语种
        var lang = typeof keyValue === 'object' && keyValue.lang
            ? keyValue.lang
            : this.currentLang;
        return (0, StringFomat_1.format)({
            id: id,
            defaultString: defaultString,
        }, variable || null, {
            name: this.name,
            nameSpace: nameSpace,
            lang: lang,
        });
    };
    /** 在当前$i18n实例中添加翻译文案 */
    I18n.prototype.addLocale = function (locale) {
        this.locale = (0, merge_1.default)(this.locale, locale);
        (0, StringFomat_1.setLocaleToInstance)(this.locale, this.name);
    };
    /** 在当前$i18n实例增量添加翻译文案 */
    I18n.prototype.addLocaleByKey = function (locale) {
        var _this = this;
        (0, forEach_1.default)(locale, function (langLocale, key) {
            (0, forEach_1.default)(langLocale, function (value, lang) {
                _this.locale[lang] = _this.locale[lang] || {};
                _this.locale[lang][key] = value;
            });
        });
        (0, StringFomat_1.setLocaleToInstance)(this.locale, this.name);
    };
    /** 设置该实例的自定义的lang (pls understand) */
    I18n.prototype.setCustomLang = function (lang) {
        this.currentLang = lang;
        this.customLang = lang;
    };
    /** 根据key返回翻译列表 */
    I18n.prototype.getLocaleByKey = function (key) {
        var myLocale = {};
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        (0, forEach_1.default)(this.locale, function (locale, lang) {
            myLocale[lang] = locale[key] || '';
        });
        return myLocale;
    };
    return I18n;
}());
exports.I18n = I18n;
// _init 标记为默认的$i18n实例（cdn）
var defaultI18n = new I18n({ _init: true });
var init = function (params) { return defaultI18n.init(params); };
exports.init = init;
exports.default = defaultI18n;
